/**
 * Pure routing decisions for the /auth/action handler page. Extracted so the
 * mode + oobCode → behavior matrix is unit-testable without spinning up React
 * or mocking Firebase Auth. See [[tasks/branded-auth-emails-and-action-handler]].
 */

export type AuthActionMode =
  | "resetPassword"
  | "verifyEmail"
  | "recoverEmail"
  | "unsupported";

export type AuthActionDecision =
  | { kind: "missing-code" }
  | { kind: "unsupported" }
  | { kind: "needs-verify-reset" }
  | { kind: "needs-apply-verify" };

const KNOWN_MODES = new Set(["resetPassword", "verifyEmail", "recoverEmail"]);

export function normalizeMode(raw: string | null | undefined): AuthActionMode {
  if (raw && KNOWN_MODES.has(raw)) return raw as AuthActionMode;
  return "unsupported";
}

export function decideAuthAction(
  mode: AuthActionMode,
  oobCode: string | null | undefined,
): AuthActionDecision {
  if (!oobCode) return { kind: "missing-code" };
  // recoverEmail (email-change confirmation) is intentionally not handled in
  // v1 — fall through to the same "unsupported" path until we ship the
  // email-change flow.
  if (mode === "unsupported" || mode === "recoverEmail") {
    return { kind: "unsupported" };
  }
  if (mode === "resetPassword") return { kind: "needs-verify-reset" };
  return { kind: "needs-apply-verify" };
}
